module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi4yIDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzIzMWYyMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmxhcmdlX2Fycm93PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsMjNhMSwxLDAsMCwxLC4yNi0uNjdMOS41MSwxMiwuMjYsMS42N0ExLDEsMCwwLDEsLjMzLjI2LDEsMSwwLDAsMSwxLjc1LjMzTDEyLjIsMTIsMS43NSwyMy42N2ExLDEsMCwwLDEtMS40Mi4wOEExLDEsMCwwLDEsMCwyM1oiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/large_arrow.svg
// module id = WYVp
// module chunks = 1